import { Table, Typography, Layout, Tag, Space, Button } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../utils/baseUrl";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../utils/const";
import LeadExtraModal from "../../components/leads/extraModal";
import { Lead } from "../../types/leads";

const { Title } = Typography;
const { Content } = Layout;

export default function LeadsList() {
  const { id, uuid } = useParams();
  const navigate = useNavigate();
  const [leads, setLeads] = useState<Lead[]>([])
  const [currentLead, setCurrentLead] = useState<Lead | null>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const getData = async() => {
      try {
        const {data} = await axios.get(`${baseUrl}/leads/`,{
          params: {
            org_id: id,
            org_token: uuid
          }
        })
        setLeads(data)
      } catch (e){
        console.error(e)
      }
    }

    getData()
    
  },[])

  const openModal = (_lead: Lead) => {
    setCurrentLead(_lead)
    setVisible(true)
  }

  const columns = [
    {
      title: "Nome",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Telefone",
      dataIndex: "session_id",
      key: "session_id",
    },
    {
      title: "Data Agendada",
      dataIndex: "schedule_date",
      key: "schedule_date",
      render: (schedule_date: string) => schedule_date ? dayjs(schedule_date).format(DATE_FORMAT) : ""
    },
    {
      title: "Ultimo contato",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (updated_at: string) => updated_at ? dayjs(updated_at).format(DATE_FORMAT) : ""
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_: any, record: any) => {
        const statuses = {"scheduled": {color: "green", label: "Agendado"}, "ongoingChat": {color: "blue", label: "Em conversa"}}
        const status = record.schedule_date ? "scheduled" : "ongoingChat"
  
        return <Tag color={statuses[status].color}>{statuses[status].label}</Tag>;
      },
    },
    {
      title: "Ações",
      key: "acoes",
      render: (_: any, record: any) => (
        <Space>
          <Button
            type="default"
            onClick={() => openModal(record)}
          >
            Detalhes
          </Button>
          <Button
            type="primary"
            onClick={() =>
              window.open(`/${id}/${uuid}/chats/${record.session_id}`, "_blank")
            }
          >
            Ver Chat
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Layout style={{ padding: "2rem", background: "#fff", minHeight: "100vh" }}>
      <Content>
        <Title level={2}>Leads da Organização {id}</Title>
        <Table
          columns={columns}
          dataSource={leads}
          bordered
          pagination={{ pageSize: 5 }}
        />
      </Content>
      <LeadExtraModal visible={visible} onClose={() => setVisible(false)} lead={currentLead}/>
    </Layout>
  );
}
